import type { SVGMotionProps, Transition } from 'motion/react'
import { motion } from 'motion/react'
import { useId } from 'react'

const transition: Transition = {
  duration: 0.5,
  type: 'spring',
  bounce: 0.3,
}

export const SidebarHide = ({
  isHovered,
  ...props
}: SVGMotionProps<SVGSVGElement> & { isHovered?: boolean }) => {
  const id = useId()

  return (
    <motion.svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      animate={isHovered ? 'hover' : undefined}
      whileHover="hover"
      {...props}
    >
      <mask
        id={id}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
      >
        <rect width={10} height={10.478} x={2.705} y={4.753} fill="black" />
      </mask>
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth={1.3}
        d="M4.516 4.167h10.968c1.365 0 2 .635 2 2v7.666c0 1.365-.635 2-2 2H4.516c-1.365 0-2-.635-2-2V6.167c0-1.365.635-2 2-2Z"
      />
      <motion.path
        transition={transition}
        initial={{ x: 0 }}
        variants={{ hover: { x: -3.5 } }}
        fill="currentColor"
        d="M14.168 7.08a.65.65 0 0 1 .92.92l-2.002 2 2.002 2a.65.65 0 0 1-.92.92l-2.461-2.46a.651.651 0 0 1 0-.92l2.46-2.46Z"
      />
      <g mask={`url(#${id})`}>
        <motion.path
          transition={transition}
          initial={{ x: 0 }}
          variants={{ hover: { x: -7 } }}
          fill="currentColor"
          fillRule="evenodd"
          d="M4.692 8.85a.65.65 0 1 0 0 1.3h2.083a.65.65 0 0 0 0-1.301H4.692Zm-.65-1.73a.65.65 0 0 1 .65-.65h2.083a.65.65 0 1 1 0 1.3H4.692a.65.65 0 0 1-.65-.65ZM0 4.775h9.067v10.452H0V4.774Z"
          clipRule="evenodd"
        />
      </g>
    </motion.svg>
  )
}
